module.exports = __webpack_public_path__ + "static/media/27OCHA15.841e42ce.jpg";